import axiosApiInstance from '../../interceptors/axiosApiInstance';
import {BASE_URL} from '../config';

const OperationService = {
    /**
     * @Description Service of Getting Operation Detail
     * @Param       startDate='', endDate='', operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperation: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Operations Count
     * @Param       startDate='', endDate='', operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationCount: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation/count?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Avarage Time Elapse
     * @Param       startDate='', endDate='', operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationAvgTime: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation/avg/time-elapsed?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Total Time Elapse
     * @Param       startDate='', endDate='', operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationTotalTime: async function (startDate = '', endDate = '') {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation/total/time-elapsed?startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Operation Percentage
     * @Param       startDate='', endDate='', operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationPercentage: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation/percentage?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
    ,
    /**
     * @Description Service of Top Count Bots According To Running
     * @Param       startDate='', endDate='', top=4, operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationRank: async function (startDate = '', endDate = '', operationType = 'automation', top = 4) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/operation/working/rank?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}&top=${top}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};
export default OperationService;
